// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course-curation__item[data-v-61be63bc]{scroll-snap-align:start;-webkit-user-select:none;-moz-user-select:none;user-select:none}@media(max-width:985px){.course-curation__item a[data-v-61be63bc]{width:196px}}@media(min-width:986px){.course-curation__item a[data-v-61be63bc]{width:302px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
